import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Killmoe · Your Source for News & Entertainment</p>
        <h1>Stay Informed, Stay Entertained.</h1>
        <p className="lede">
          Dive into the latest updates in pop culture, politics, and social media. Killmoe is your go-to destination for all things trending and relevant.
        </p>
        <div className="cta-row">
          <a href="/latest" target="_self">
            Explore the Latest
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Breaking News</h2>
          <p>
            Get real-time updates on the most important stories shaping our world today.
          </p>
        </article>
        <article>
          <h2>Pop Culture Buzz</h2>
          <p>
            From celebrity gossip to viral trends, stay ahead of the curve with our entertainment coverage.
          </p>
        </article>
        <article>
          <h2>Social Media Insights</h2>
          <p>
            Discover what’s trending online and how it impacts our society with our in-depth analysis.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;